import React from 'react';
import { TableCellProps } from '../../../types/search';

const PortalCellSite: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  let topValue, bottomValue;

  if (listingType === 'services') {
    topValue = row['site'];
    bottomValue = row['postcode'];
  } else if (listingType === 'jobs') {
    topValue = row['siteName'];
    bottomValue = row['sitePostcode'];
  }

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--location`}>
      {!!topValue && (
        <p>
          <strong>{topValue}</strong>
        </p>
      )}
      {!!bottomValue && <p>{bottomValue}</p>}
    </div>
  );
};

export default PortalCellSite;
